import eSystemUIControllerTypes from '../eControllerTypes';

export default {
  EIT_DISPLAY_RTP: `${eSystemUIControllerTypes.ECT_INFO_PANEL}__display_rtp`,
  EIT_NET_POSITION: `${eSystemUIControllerTypes.ECT_INFO_PANEL}__net_position`,
  EIT_GAME_STATE: `${eSystemUIControllerTypes.ECT_INFO_PANEL}__game_state`,
  EIT_STOPWATCH: `${eSystemUIControllerTypes.ECT_INFO_PANEL}__stopwatch`,
  EIT_CLOCK: `${eSystemUIControllerTypes.ECT_INFO_PANEL}__clock`,
  EIT_BALANCE: `${eSystemUIControllerTypes.ECT_INFO_PANEL}__balance`,
}
